// import utils from './index'

const methods = {}

const initNvcMap = []
const ua = navigator.userAgent.toLowerCase()

export const $nvcEvent = (function () {
  const deferMap = {}
  let currentScene = ''

  return {
    setScene: (scene) => {
      currentScene = scene
    },
    on: (key, cb) => {
      deferMap[key] = (data) => {
        cb && cb(data)
      }
    },
    emit: (data) => {
      deferMap[currentScene] && deferMap[currentScene](data)
    }
  }
})()

export function initNvc (alias, option) {
  if (initNvcMap[alias]) {
    return
  }

  initNvcMap[alias] = true

  const nvcToken = '//survey.taobao.com/survey/QgzQDdDd?token=%TOKEN'
  const nvcOption = {
    // 无痕配置 && 滑动验证、刮刮卡、问答验证码通用配置
    // 应用类型标识。它和使用场景标识（scene字段）一起决定了无痕验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
    appkey: 'CF_APP_1',
    // 使用场景标识。它和应用类型标识（appkey字段）一起决定了无痕验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的scene值，请务必正确填写。
    scene: 'nvc_register',
    isH5: false,
    popUp: false,
    renderTo: '',
    /**
     * 滑块成功后的回调
     * data跟业务请求一起上传，由后端请求AnalyzeNvc接口，接口会返回100或者900
     * @param {String} data getNVCVal()的值，此函数为二次验证滑动或者刮刮卡通过后的回调函数
     */
    nvcCallback: function (data) {
      // 通过自定义的广播事件，执行业务层已定义好的回调，通常是再次执行之前的方法
      $nvcEvent.emit(data)

      // store.commit(types.CHECK_NVC_ACTIVATED, false)
    },
    language: 'cn',
    // 滑动验证长度配置
    customWidth: 'auto',
    // 刮刮卡配置项
    width: 300,
    height: 100,
    elements: [
      '//img.alicdn.com/tfs/TB17cwllsLJ8KJjy0FnXXcFDpXa-50-74.png',
      '//img.alicdn.com/tfs/TB17cwllsLJ8KJjy0FnXXcFDpXa-50-74.png'
    ],
    bg_back_prepared: '//img.alicdn.com/tps/TB1skE5SFXXXXb3XXXXXXXXXXXX-100-80.png',
    bg_front: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABQCAMAAADY1yDdAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURefk5w+ruswAAAAfSURBVFjD7cExAQAAAMKg9U9tCU+gAAAAAAAAAIC3AR+QAAFPlUGoAAAAAElFTkSuQmCC',
    obj_ok: '//img.alicdn.com/tfs/TB1rmyTltfJ8KJjy0FeXXXKEXXa-50-74.png',
    bg_back_pass: '//img.alicdn.com/tfs/TB1KDxCSVXXXXasXFXXXXXXXXXX-100-80.png',
    obj_error: '//img.alicdn.com/tfs/TB1q9yTltfJ8KJjy0FeXXXKEXXa-50-74.png',
    bg_back_fail: '//img.alicdn.com/tfs/TB1w2oOSFXXXXb4XpXXXXXXXXXX-100-80.png',
    upLang: {
      cn: {
        _ggk_guide: '请摁住鼠标左键，刮出两面盾牌',
        _ggk_success: '恭喜您成功刮出盾牌<br/>继续下一步操作吧',
        _ggk_loading: '加载中',
        _ggk_fail: ['呀，盾牌不见了<br/>请', 'javascript:noCaptcha.reset()', '再来一次', '或', nvcToken, '反馈问题'],
        _ggk_action_timeout: ['我等得太久啦<br/>请', 'javascript:noCaptcha.reset()', '再来一次', '或', nvcToken, '反馈问题'],
        _ggk_net_err: ['网络实在不给力<br/>请', 'javascript:noCaptcha.reset()', '再来一次', '或', nvcToken, '反馈问题'],
        _ggk_too_fast: ['您刮得太快啦<br/>请', 'javascript:noCaptcha.reset()', '再来一次', '或', nvcToken, '反馈问题']
      }
    }
  }

  window.NVC_Opt = Object.assign(nvcOption, option)

  asyncLoadJs('//g.alicdn.com/sd/nvc/1.1.112/guide.js')
}

export function initNvcMessage (domID) {
  // const nvcDom = document.createElement('div')

  // nvcDom.id = domID
  // parent.appendChild(nvcDom)

  const isMobile = /iphone|android|ucweb|ucbrowser|nokia|sony|ericsson|mot|samsung|sgh|lg|philips|panasonic|alcatel|lenovo|cldc|midp|wap|mobile/i.test(ua) || /ipad/i.test(ua)
  const option = {
    // 使用场景标识。它和应用类型标识（appkey字段）一起决定了无痕验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的scene值，请务必正确填写。
    appkey: 'FFFF0N00000000009834',
    scene: isMobile ? 'nvc_message_h5' : 'nvc_message',
    // appkey: 'CF_APP_1',
    // scene: 'nvc_register',
    isH5: isMobile,
    renderTo: `#${domID}`
    // 无痕验证通过
    // trans: {nvcCode: 200}
    // 唤醒滑动验证，且滑动验证通过
    // trans: {nvcCode: 400, key1: 'code0'}
    // 唤醒滑动验证，且滑动验证未通过（拦截）
    // trans: {nvcCode: 400, key1: 'code300'}
    // 无痕验证未通过，直接拦截
    // trans: {nvcCode: 800}
    // trans: {},
  }

  initNvc('message', option)
}

/**
 * 开启阿里云盾的滑块验证
 * @param {String} code 错误码
 * @param {String} scene 使用场景
 * @return {Boolean} 是否命中云盾验证
 */
export function nvcError (code, scene) {
  if (code === '-2800' || code === '-2900') {
    resetNC()

    return false
  }

  $nvcEvent.setScene(scene)

  return true
}

/**
 * 显示阿里云盾的滑块验证
 */
export function showNC () {
  window.getNC().then(() => {
    window._nvc_nc.upLang('cn', {
      _startTEXT: '请按住滑块，拖动到最右边',
      _yesTEXT: '验证通过',
      _error300: '哎呀出错了，点击<a href="javascript:__nc.reset()">刷新</a>再来一次',
      _errorNetwork: '网络不给力，请<a href="javascript:__nc.reset()">点击刷新</a>'
    })

    window._nvc_nc.reset()
  })
}

/**
 * 重置滑块验证
 */
export function resetNC () {
  window.nvcReset()
}

export function nvcDemo (url, params) {
  var callbackName = ('jsonp_' + Math.random()).replace('.', '')

  params += '&callback=' + callbackName

  const oScripts = document.getElementsByTagName('script')[0]
  const oS = document.createElement('script')

  oScripts.parentNode.insertBefore(oS, oScripts)
  // 您注册请求的业务回调
  window[callbackName] = function (json) {
    // if (json.result.code === 400) {
    //   // 唤醒滑动验证
    //   window.getNC().then(function () {
    //     window._nvc_nc.upLang('cn', {
    //       _startTEXT: '请按住滑块，拖动到最右边',
    //       _yesTEXT: '验证通过',
    //       _error300: '哎呀，出错了，点击<a href="javascript:__nc.reset()">刷新</a>再来一次',
    //       _errorNetwork: '网络不给力，请<a href="javascript:__nc.reset()">点击刷新</a>'
    //     })

    //     window._nvc_nc.reset()
    //   })
    // } else if (json.result.code === 800 || json.result.code === 900) {
    //   // 直接拦截
    //   window.nvcReset()
    //   alert('register failed!')
    // }
  }

  oS.src = url + '?' + params
}

export default methods

/**
 * 动态引入 js 文件
 * @param {String} url js 文件地址
 */
function asyncLoadJs (url) {
  return new Promise((resolve, reject) => {
    const srcArr = document.getElementsByTagName('script')
    let hasLoaded = false

    // 判断当前js是否加载上
    for (let i = 0; i < srcArr.length; i++) {
      hasLoaded = srcArr[i].src === url
    }

    if (hasLoaded) {
      resolve()

      return
    }

    const script = document.createElement('script')

    script.type = 'text/javascript'
    script.src = url
    document.body.appendChild(script)

    script.onload = () => {
      resolve()
    }

    script.onerror = (err) => {
      reject(err)
    }
  })
}
